import React from 'react';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './popup.scss';

export default ({ isOpen, toggle, title, content, link, onClickHander }) => {
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='next-step-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div className='modal-content'>
              <h6 className='my-2 mb-4'>{content}</h6>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>

            <Button
              type='app-green-button submitBtn'
              handleClick={() => {
                toggle(!isOpen)
              }}>
              No
            </Button>
            <Button
              type='app-green-button'
              handleClick={() => {
                onClickHander('Yes')
              }}>
              Continue
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
